module.exports = __webpack_public_path__ + "static/favicon-9ed99413d3329b52d5a074c11bb040ee.png";